import React, { useState } from 'react';

const RegisterPage = ({ register, setCurrentPage }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleRegister = () => {
    if (!email || !password || !username) {
      setError('Please fill in all fields');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    const result = register(email, password, username);
    if (result.success) {
      setSuccess('Registration successful! You can now login.');
      setError('');
      setTimeout(() => {
        setCurrentPage('login');
      }, 2000);
    } else {
      setError(result.error);
      setSuccess('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleRegister();
    }
  };

  return (
    <div className="container">
      <div className="header">
        <h1>🌱 EcoFinds</h1>
        <p>Join Our Sustainable Community</p>
      </div>
      
      <div className="form">
        <h2>Create Your Account</h2>
        {error && <div className="error">{error}</div>}
        {success && <div className="success">{success}</div>}
        
        <input
          type="email"
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        
        <input
          type="password"
          placeholder="Password (min 6 characters)"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        
        <button onClick={handleRegister}>
          Create Account
        </button>
        
        <button onClick={() => setCurrentPage('login')}>
          Already have an account? Login
        </button>
      </div>
    </div>
  );
};

export default RegisterPage;